import { FieldNames } from 'v2/core/entities/fields';
import { EQLProps } from 'v2/core/repository/eql/types';

export function getGroupBy(fieldName: FieldNames): EQLProps['groupBy'] {
  switch (fieldName) {
    case FieldNames.Entity:
      return { entity: true };
    case FieldNames.ReviewSentiment:
      return { recordSentiment: true };
    case FieldNames.Language:
      return { language: true };
    case FieldNames.Reason:
      return { reason: true };
    case FieldNames.Source:
      return { source: true };
    default:
      return undefined;
  }
}
